import { render, staticRenderFns } from "./birimbazlihedeftoplamlaritablosu.vue?vue&type=template&id=3245f7ca"
import script from "./birimbazlihedeftoplamlaritablosu.vue?vue&type=script&lang=js"
export * from "./birimbazlihedeftoplamlaritablosu.vue?vue&type=script&lang=js"
import style0 from "./birimbazlihedeftoplamlaritablosu.vue?vue&type=style&index=0&id=3245f7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports